import EngineModule from '../EngineModule';
import {NS as PlannerFloorEditor} from '../components/viewer/planner/floor/Editor/PlannerFloorEditor';

export default () => EngineModule.all.find(x => x.id === 'viewer-planner-floor-editor') || new EngineModule.UIEngineModule({
	type: 'ui',
	useFullWidth : false,
	id: 'viewer-planner-floor-editor',
	allowedCustomers: null,
	dependencies: [
		'viewer-planner',
		'oms-basket'
	],
	modulesBefore: ['product-editor', 'viewer-planner-layout-editor', 'viewer-planner-dimensionsEditor'],
	modulesAfter: ['viewer-planner-furniture-editor'],
	usableCondition: {
		type: 'and',
		LHS: {
			type: 'notequal',
			component: 'K.basket',
			property: 'TARGET.basket.currentProduct',
			value: null
		},
		RHS: {
			type: 'or',
			LHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.hasPart(["layout"])',
				value: true
			},
			RHS: {
				type: 'notequal',
				component: 'K.basket',
				property: '[*]TARGET.basket.currentProduct.getPart(["layout"]).currentOption',
				value: null
			}
		}
	},
	displayCondition: null,
	generateComponentConfiguration(): PlannerFloorEditor.Configuration {
		return {
			allFree: this.configuration.allFree ? true : false
		};
	}
});
